import React, { FC, useEffect, useRef, useState } from 'react';
import CheckboxAnt from 'antd/lib/checkbox';
import clsx from 'clsx';
import styles from '@pages/offers/Filters/index.module.scss';

interface ITrafficSourceOption {
    categoryOption: {
        label: string;
        value: number;
        isChecked: boolean;
    };
    onChange: (categoryId: number) => void;
}

const CategoryOption: FC<ITrafficSourceOption> = ({ categoryOption, onChange }) => {
    const textRef = useRef<HTMLSpanElement>(null);
    const [isEllipsis, setIsEllipsis] = useState(false);

    useEffect(() => {
        if (!textRef.current) return;

        const observer = new ResizeObserver(() => {
            if (textRef.current) {
                setIsEllipsis(textRef.current.scrollWidth > textRef.current.clientWidth);
            }
        });

        observer.observe(textRef.current);

        return () => observer.disconnect(); //eslint-disable-line
    }, [categoryOption.label]);

    return (
        <p className={`${styles.tooltip} w-full xs:w-[45%] sm:w-[30%] md:w-full`}>
            <CheckboxAnt
                id={`category${categoryOption.value}`}
                key={`category${categoryOption.value}`}
                name={`category${categoryOption.value}`}
                checked={categoryOption.isChecked}
                className="text-blueGray-500"
                onChange={() => onChange(categoryOption.value)}
            >
                <span
                    className={clsx(styles.category, {
                        'text-blueGray-800': categoryOption.isChecked,
                    })}
                    ref={textRef}
                >
                    {categoryOption.label}
                </span>
            </CheckboxAnt>
            {isEllipsis && <span className={styles.tooltip_text}>{categoryOption.label}</span>}
        </p>
    );
};

export default CategoryOption;
